import { useFlags } from '@mint-lib/routing-context';
import {
  ChatSendButton,
  ChatStopButton,
  ChatVoiceButton,
} from '@mint-lib/tw-components/ai';

type Props = {
  hasMessage: boolean;
  isDisabled: boolean;
  isInterruptible?: boolean;
  isS2SMode: boolean;
  isInterruptSuccess?: boolean;
  isInterruptPending?: boolean;
  handleSendQuestion: () => void;
  onStartVoiceChat?: () => void;
  onInterrupt?: () => void;
};

export const SendMessageButton = ({
  hasMessage,
  isS2SMode,
  isDisabled,
  isInterruptible,
  isInterruptSuccess,
  isInterruptPending,
  handleSendQuestion,
  onStartVoiceChat,
  onInterrupt,
}: Props) => {
  const ff = useFlags('@mint/arm', ['aiHubS2S']);

  const isS2SAvailable = ff.aiHubS2S.enabled && onStartVoiceChat;

  if (isS2SAvailable && isS2SMode && !isDisabled) {
    return <ChatVoiceButton onClick={onStartVoiceChat} />;
  }

  if (isInterruptible && !isInterruptSuccess) {
    return (
      <ChatStopButton isLoading={isInterruptPending} onClick={onInterrupt} />
    );
  }

  return (
    <ChatSendButton
      onClick={handleSendQuestion}
      disabled={isDisabled || !hasMessage}
    />
  );
};
